import { cn } from "@/lib/utils";
import Link from "next/link";

const Button = ({
  text,
  onClick,
  type = "button",
  variant = "primary",
  className = "",
  disabled = false,
  icon = null,
  ...props
}) => {
  const baseClasses =
    "px-4 py-2 w-fit h-fit rounded-md focus:outline-none transition duration-300";
  const variantClasses = {
    primary:
      "bg-basecolor text-white hover:bg-basecolor-hover transform transition-all duration-300 hover:scale-105",
    secondary:
      "bg-gray-700 text-white hover:bg-gray-900 transform transition-all duration-300 hover:scale-105",
    danger:
      "bg-red-700 text-white hover:bg-red-900 transform transition-all duration-300 hover:scale-105",
    success:
      "bg-green-700 text-white hover:bg-green-900 transform transition-all duration-300 hover:scale-105",
  };

  const buttonClasses = `${baseClasses} ${
    variantClasses[variant]
  } ${className} ${disabled && "opacity-50 cursor-not-allowed"}`;

  if (props.href) {
    return (
      <div className="group relative my-4 py-2.5 w-full bg-green-2 overflow-hidden rounded-md">
        <div className="absolute inset-0 transition-all duration-1000 ease-in-out transform scale-x-0 bg-gradient-to-r from-green-2 to-green-11 group-hover:scale-x-100"></div>
        <Link
          target={props.target}
          href={props.href}
          className={cn(
            "relative z-10 flex items-center justify-center w-full h-full text-sm font-semibold text-white",
            className
          )}
        >
          {text}
          {icon && <span className="ml-1 lg:ml-3">{icon}</span>}
        </Link>
      </div>
    );
  } else if (props.children) {
    return (
      <button
        type={type}
        className={cn(buttonClasses, className)}
        onClick={onClick}
        disabled={disabled}
        {...props}
      >
        {props.children}
      </button>
    );
  } else {
    return (
      <button
        aria-label={props.ariaLabel}
        type={type}
        className={cn(buttonClasses, className)}
        onClick={onClick}
        disabled={disabled}
        {...props}
      >
        {icon && <span>{icon}</span>}
        {text}
      </button>
    );
  }
};

export default Button;
